import { render, staticRenderFns } from "./opportunity-details-widget.vue?vue&type=template&id=77ca0d1b&"
import script from "./opportunity-details-widget.vue?vue&type=script&lang=js&"
export * from "./opportunity-details-widget.vue?vue&type=script&lang=js&"
import style0 from "./opportunity-details-widget.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports